module.exports = __webpack_public_path__ + "static/media/cedric.99887cda.mp4";